const commonOptions = {
  headerClass: '',
  contentClass: 'delete-modal-content',
  footerClass: `cascade-1-md:w-40 cascade-1-w-full cascade-1-p-y-0`,
  bodyClass: 'p-0',
  hideHeader: true,
  hideHeaderClose: true,
  centered: true
}
const negativeMessageParts = {
  message: 'Are you sure?',
  information: '',
}
const negativeOptions = {
  title: '',
  okTitle: 'Ok',
  okVariant: 'primary',
  headerClass: 'tx-weight-bold',
  noCloseOnBackdrop: true,
  noCloseOnEsc: true,
}
export const deleteBoxOptions = {
  ...commonOptions,
  cancelTitle: 'Cancel',
  okTitle: 'Yes, Delete',
  okVariant: 'danger',
}
export const okBoxOptions = {
  ...commonOptions,
  okTitle: 'OK',
}

function generateContent(h, message, options = {}) {
  const VHeader = h('div', { class: ['custom-border-header pt-3'] }, [
    h('div', { class: ['custom-border-header-content text-primary pb-3', options.headerClass ] }, [
      h('p', { class: ['tw-px-5']}, options.title ),
    ])
  ])
  let VBody;

  if (Array.isArray(message)){
    let VMessage = [];
    message.forEach((para, index) => {
      if (index !== 0){
        VMessage.push(h('br'));
      }
      VMessage.push(h('p', {} , para));
    })
    VBody = h('div', { class: ['p-4'] }, VMessage)
  } else {
    VBody = h('div', { class: ['p-4'] }, [ message ])
  }

  let VContent = [ VBody ];
  if (!options.hideHeader) {
    VContent = [ VHeader, ...VContent ]
  }
  return h('div', null, VContent)
}
export function msgBoxConfirmPopup(message, options = {}) {
  const h = this.$createElement
  const content = generateContent(h, message, options)
  return this.$bvModal.msgBoxConfirm([ content ], { ...deleteBoxOptions, ...options })
}
export function msgBoxOKPopup(message, options = {}) {
  const h = this.$createElement
  const content = generateContent(h, message, options)
  return this.$bvModal.msgBoxOk([ content ], { ...okBoxOptions, ...options })
}
export function negativeStateConfirmPopup(messageParts, options = {}, showCancel = true) {
  const ce = this.$createElement
  const deliveredMessage = ce('p',
    { class: ['tw-mb-0'] },
    [
      ce('span', { class: ['tx-weight-bold'] }, {...negativeMessageParts, ...messageParts}.message),
      ce('br'),
      ce('br'),
      {...negativeMessageParts, ...messageParts}.information,
    ]
  )

  const content = generateContent(ce, deliveredMessage, {...negativeOptions, ...options})
  if (showCancel){
    return this.$bvModal.msgBoxConfirm([ content ], { ...deleteBoxOptions, ...negativeOptions, ...options })
  }else{
    return this.$bvModal.msgBoxOk([ content ], { ...okBoxOptions, ...negativeOptions, ...options })
  }
}
